import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Kontaktdaten } from '../../domain/model/kontaktdaten';

@Injectable({
    providedIn: 'root',
})
export class WestnetzKontaktdatenService {

    private readonly SERVICE_URL = `${environment.API_URL}/kontaktdaten`;

    private httpClient = inject(HttpClient);

    public listWestnetzKontaktdaten(stadtwerkeId: string): Observable<Kontaktdaten[]> {
        let params = new HttpParams();
        params = params.set('stadtwerkeId', stadtwerkeId);

        return this.httpClient.get<Kontaktdaten[]>(this.SERVICE_URL, { params });
    }


}
